/**
 * @format
 */

 export const LOADING_JOB_DETAILS = 'loading_job_details';
 export const ADD_JOB = 'add_job';
